
import Box from '@mui/material/Box';
import { useRef } from 'react'

const sx = {
    box: {
        display: "flex",
        gap: "10px",
        justifyContent: 'center',

        input: {
            width: "38px",
            height: "45px !important",
            textAlign: "center",
            color: "#0A78CD !important",
            fontSize: "20px !important",
            fontWeight: "400",
            lineHeight: '32px',
            fontFamily: 'poppins',
            border: "none !important",
            outline: "none",
            borderRadius: '5px',

        }
    }
}

export default function OtpTextBox({ length, onComplete }) {
    let values = {};
    let ref = useRef(null);
    let arr = Array.from(Array(length).keys());

    const handleKeyPress = e => {
        var regex = new RegExp('^[0-9]+$')
        var key = String.fromCharCode(!e.charCode ? e.which : e.charCode)
        if (!regex.test(key)) {
            return false
        }
    }

    function handleOnChange(value, name) {
        values[name] = value;
        if (name === length - 1 && Object.values(values).filter(x => x).length === length) {
            let value = Object.values(values).join('');
            if (onComplete) {
                onComplete(value);
            }
        }
    }

    function handleNextInput(event, name) {
        event.preventDefault();
        handleBackspace(event);

        if (/^\d+$/.test(event.key) === false) return;
        let elements = getElements();
        const index = [...elements].indexOf(event.target);
        const elem = elements[index + 1];
        if (elem) {
            elem.focus();
            elem.select();
        }

        handleOnChange(event.key, name);

    }

    function handleBackspace(event) {
        if (event.key !== "Backspace") return;

        event.target.value = "";
        let elements = getElements();
        const index = [...elements].indexOf(event.target);
        const elem = elements[index - 1];

        if (elem) {
            elem.focus();
            elem.select();
        }

        onComplete("");
    }

    function handlePaste(event) {
        event.preventDefault();
        let paste = (event.clipboardData || window.clipboardData).getData('text');
        if (!paste) return;

        let chars = paste.split("").map(x => Number(x)).filter(x => typeof x === "number");

        let value = "";
        [...getElements()].forEach((elem, index) => {
            elem.value = chars[index] ?? "";
            if (chars[index] !== undefined) {
                value += chars[index];
                elem.focus()
            }
        });

        if (value.length === length) {
            onComplete(value);
        }
    }

    function getElements() {
        return ref.current.querySelectorAll('input')
    }

    return (
        <Box sx={sx.box} ref={ref}>
            {arr.map((i) => {
                return <input type="text" maxLength="1" autoComplete='off' name={i} onKeyDown={handleKeyPress} onKeyUp={(e) => handleNextInput(e, i)} onClick={(e) => { e.target.select() }} onPaste={handlePaste} />
            })}
        </Box>
    );
}